import React, { Component } from 'react';
import { getTranslation } from '../Utilities/GetTranslation';

class NamezzzSalary extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onPeriodChange = this.onPeriodChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    onChange(e) {
        e.target.value = e.target.value.replace(/\D/g,'');
        this.props.onChange(e);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    onPeriodChange(e) {
        this.props.onPeriodChange(e);
    }

    render() {
        return (
            <div className="tr form-inline">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.id}>{this.props.text}</label>
                </div>
                <div className="EditingFormValueCell td">
                    <input id={this.props.id} className="form-control" type="text" onChange={this.onChange} onKeyPress={this.onKeyPress} maxLength="6" value={this.props.value} />
                    &nbsp;{getTranslation("sns.webparts.salary.period")}&nbsp;
                    <select id={this.props.id + "Period"} className="form-control" onChange={this.onPeriodChange} value={this.props.period}>
                        {
                            (this.props.periodData == null) ?
                                "" :
                                this.props.periodData.map((option) =>
                                    <option key={option.key} value={option.key}>{option.value}</option>
                                )
                        }
                    </select>                    
                </div>
            </div>
        );
    }
}

export default NamezzzSalary;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzSalary.js